import def from './config.default.json';

let config;


try {
  config = require('./config.json');
  // do stuff
} catch (_) {
  config = {};
}

export default {
  ...def,
  ...config
};
